import axios from 'axios'

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '' : ''
axios.defaults.timeout = 120000
console.log('env----' + process.env.NODE_ENV)
const api = process.env.NODE_ENV === 'development' ? "/api" : ""

const get = async (url, params = {}) => {
	try {
		const res = await axios.get(api + url, { params });
		return res.data || {}
	} catch (e) {
		return {
			code: -1,
			message: e.message,
			status: false
		};
	}
};

const post = async (url, params = {}) => {
	try {
		const res = await axios.post(api + url, params);
		return res.data || {};
	} catch (e) {
		return {
			code: -1,
			message: e.message,
			status: false
		}
	}
};

export { get, post }
